export default __webpack_public_path__ + "img/img_senggi-0906a9258ebc65ddb47644a96d5f921c.png";